module.exports = __webpack_public_path__ + "img/charactors.38f9d73c.png";